import { TelemetryClient } from '@tableau/telemetry-api-contract';

// tslint:disable-next-line: no-any
function mapNameValuePairsToObject(pairs: any[]): {} {
  const returnVal: { [id: string]: boolean | number | string } = {};
  for (let i = 0; i < pairs.length; i += 2) {
    if (typeof pairs[i] !== 'string') {
      continue;
    }
    const key = <string>pairs[i];
    const value = pairs[i + 1];
    switch (typeof value) {
      case 'string':
      case 'number':
      case 'boolean':
        returnVal[key] = value;
        break;
      default:
        continue;
    }
  }
  return returnVal;
}

export interface TelementryInterop {
  ForwardTelemetry(eventType: string, propertyObject: Object): Promise<void>;
}

export class DesktopTelemetryClient implements TelemetryClient {
  private static _instance: TelementryInterop;

  // tslint:disable-next-line: no-any
  public async reportEvent(eventType: string, nameValuePairs: any[]): Promise<void> {
    try {
      await DesktopTelemetryClient._instance.ForwardTelemetry(eventType, mapNameValuePairsToObject(nameValuePairs));
    } catch (e) {
      // tslint:disable-next-line: no-console
      console.log('Error sending telemetry', e);
    }
  }

  /** setInstance is called from QtWebChannelImpl as the desktop interop is getting initialized */
  public static setInstance(instance: TelementryInterop): void {
    this._instance = instance;
  }
}
